import { DateRange } from '@customerio/fly-components/utils/fly-date-picker-utils';
import {
  LAST_24_HOURS_FROM_NOW_RANGE_PRESET,
  LAST_7_DAYS_RANGE_PRESET,
  LAST_30_DAYS_RANGE_PRESET,
  LAST_12_WEEKS_RANGE_PRESET,
  LAST_12_MONTHS_RANGE_PRESET,
} from 'cio/utils/workflow-metrics';
import { Grouping } from 'cio/utils/metrics/common';

export const DATE_RANGE_PRESETS = [
  LAST_24_HOURS_FROM_NOW_RANGE_PRESET,
  LAST_7_DAYS_RANGE_PRESET,
  LAST_30_DAYS_RANGE_PRESET,
  LAST_12_WEEKS_RANGE_PRESET,
  LAST_12_MONTHS_RANGE_PRESET,
];

export const getDateRangePresetByValue = (value: string) => {
  return DATE_RANGE_PRESETS.find((preset) => preset.value === value) ?? LAST_30_DAYS_RANGE_PRESET;
};

export const resolutionByRange = (range: DateRange): Grouping => {
  // Calculate the total duration of the range in various units
  let totalHours = range.end.diff(range.start, 'hours') + 1;
  let totalDays = range.end.diff(range.start, 'days') + 1;
  let totalWeeks = range.end.diff(range.start, 'weeks') + 1;
  let totalMonths = range.end.diff(range.start, 'months') + 1;

  // Choose the highest resolution that does not exceed 30 intervals
  if (totalHours <= 30) {
    return Grouping.Hourly;
  } else if (totalDays <= 30) {
    return Grouping.Daily;
  } else if (totalWeeks <= 30) {
    return Grouping.Weekly;
  } else if (totalMonths <= 30) {
    return Grouping.Monthly;
  }

  return Grouping.Monthly;
};
